import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BottomNav.css';
import { LuShoppingBag, LuHistory, LuUserRound } from 'react-icons/lu';
import { useDispatch } from 'react-redux';
import { TbTruckDelivery } from 'react-icons/tb';
import { TbHistoryToggle } from 'react-icons/tb';
import { TbFileInvoice } from 'react-icons/tb';
import { RiShoppingBag2Line } from 'react-icons/ri';
import useOrderLogic from '../../Orders/UserOrderFunction';

const BottomNav = () => {
    const navigate = useNavigate();
    const { editing } = useOrderLogic();
    const storedUserData = sessionStorage.getItem("user");
    const dispatch = useDispatch();
    const activeIcons = sessionStorage.getItem('activeIcon')
    const [activeIcon, setActiveIcon] = useState(activeIcons ? activeIcons : 'shop');
    // const userParse = JSON.parse(storedUserData);
    // const user = decryptUserInfo(userParse);
    const handleNavigation = (route, icon) => {
        setActiveIcon(icon);
        const editMode = localStorage.getItem('Edit');

        if (editMode) {
            sessionStorage.removeItem('cartItems');
            localStorage.removeItem('Edit');
        }
        sessionStorage.setItem('activeIcon', icon)
        sessionStorage.removeItem('HistoryDetails');
        localStorage.removeItem('PAGEData')
        navigate(route);
    };

    return (
        <div className="bottom-nav">
            {/* {user && user[0]?.CATEGORY === 'S1' && ( */}
            <>
                <button className={`bottom-nav-icons ${activeIcon === 'shop' ? 'active-icon' : ''}`}
                    onClick={() => handleNavigation('/sales/', 'shop')}
                    aria-label="Shop">

                    <LuShoppingBag size={24} />
                    <span className="nav-text">Shop</span>
                    {activeIcon === 'shop' && <div className="indicator"></div>}
                </button>

                <button className={`bottom-nav-icons ${activeIcon === 'history' ? 'active-icon' : ''}`}
                    onClick={() => handleNavigation('/sales/OrderHistory', 'history')}
                    aria-label="History">

                    <TbHistoryToggle size={24} />
                    <span className="nav-text">History</span>
                    {activeIcon === 'history' && <div className="indicator"></div>}
                </button>

                <button className={`bottom-nav-icons ${activeIcon === 'DeliveryHistory' ? 'active-icon' : ''}`}
                    onClick={() => handleNavigation('/sales/deliveryHistory', 'DeliveryHistory')}
                    aria-label="Account">
                    <TbTruckDelivery size={24} />
                    <span className="nav-text">Delivery</span>
                    {activeIcon === 'DeliveryHistory' && <div className="indicator"></div>}
                </button>

                <button className={`bottom-nav-icons ${activeIcon === 'Invoices' ? 'active-icon' : ''}`}
                    onClick={() => handleNavigation('/sales/invoiceHistory', 'Invoices')}
                    aria-label="Invoices">

                    <TbFileInvoice size={24} />
                    <span className="nav-text">Invoices</span>
                    {activeIcon === 'Invoices' && <div className="indicator"></div>}
                </button>


                <button className={`bottom-nav-icons ${activeIcon === 'account' ? 'active-icon' : ''}`}
                    onClick={() => handleNavigation('/sales/Account', 'account')}
                    aria-label="Account">

                    <LuUserRound size={24} />
                    <span className="nav-text">Account</span>
                    {activeIcon === 'account' && <div className="indicator"></div>}
                </button>


            </>
            {/* )} */}
        </div>)
}

export default BottomNav;

